import styled from 'styled-components';

import LogoImage from '../../assets/images/logoMeta.png';
import Search from '../../components/Search';
import { Title } from '../../components/Text';

type MainContainer = {
  imageBuffer?: Buffer;
};

export const Container = styled.main<MainContainer>`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  background-color: ${(props) => props.theme.colors.background};
`;

/* ── Header (Aparece após a pesquisa) ── */
export const Header = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  width: 100%;
  height: 64px;
  padding: 0 2rem;
  background-color: ${(props) => props.theme.colors.background};
  border-bottom: 1px solid ${(props) => props.theme.colors.border};
  box-shadow: ${(props) => props.theme.shadows.sm};
  animation: fadeIn 0.3s ease;

  @media (max-width: 600px) {
    flex-direction: column;
    height: auto;
    padding: 0.875rem 1rem;
    gap: 0.75rem;
    position: sticky;
  }
`;

export const HeaderBrand = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;
`;

export const Logo = styled.img.attrs({
  src: LogoImage,
  alt: 'Meta Globaltech',
})`
  height: 36px;
  width: auto;
  object-fit: contain;
`;

export const HeaderSearch = styled(Search)`
  width: 100%;
  max-width: 420px;

  @media (max-width: 600px) {
    max-width: 100%;
  }
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;

  @media (max-width: 600px) {
    display: none;
  }
`;

/* ── Home / Welcome State Centralizado ── */
export const HomeCentered = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
  gap: 2rem;
  animation: fadeInUp 0.4s ease both;
`;

export const HomeLogo = styled.img.attrs({
  src: LogoImage,
  alt: 'Meta Globaltech',
})`
  height: 90px;
  width: auto;
  object-fit: contain;
  margin-bottom: 1rem;
`;

export const HomeSearch = styled(Search)`
  width: 100%;
  height: 3.5rem; /* Container height override */
  box-shadow: ${(props) => props.theme.shadows.sm};
  
  /* Sobrescrevendo o input diretamente no HomeSearch com maior especificidade */
  input {
    font-size: 16px;
  }
  
  /* Sobrescrevendo o button diretamente no HomeSearch */
  button {
    width: 3.5rem;
    font-size: 24px;
  }
`;

export const HomeInstruction = styled.p`
  font-size: 15px;
  color: ${(props) => props.theme.colors.textMuted};
  text-align: center;
  line-height: 1.5;
`;

/* ── Page Body (Resultados da pesquisa) ── */
export const PageBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 96px 1.5rem 2rem;

  @media (max-width: 600px) {
    padding: 1.5rem 1rem 2rem;
  }
`;

/* ── Code Box (valor do QR Code) ── */
export const CodeBox = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0.875rem;
  background-color: ${(props) => props.theme.colors.primaryMuted};
  border: 1px solid ${(props) => props.theme.colors.primaryLight};
  border-radius: 99px;
  margin-bottom: 1.25rem;
`;

export const Code = styled(Title)`
  font-size: 12px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.primary};
  letter-spacing: 1px;
  text-transform: uppercase;
`;

/* ── Info boxes (Imbel/SaaS fallback) ── */
interface InfoContainerProps {
  loading?: boolean;
}

export const InfoContainer = styled.section<InfoContainerProps>`
  width: 100%;
  max-width: 720px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
  animation: fadeInUp 0.35s ease both;
`;
